//CSS
import cssClasses from "./AddTokenModal.module.css";
//Sub Components
import CustomInput from "../../Subcomponents/CustomInput";
import CustomSwitch from "../../Subcomponents/CustomSwitch";
import DropDown from "../../Subcomponents/DropDown";
import Button from "../../Subcomponents/Button";
import CustomRadio from "../../Subcomponents/CustomRadio";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
//MUI
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";

import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";

import { supabase } from "../../supabaseClient";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { useEffect, useState } from "react";
import { debounce } from "lodash";
import { Network } from "@capacitor/network";

function AddTokenModal(props) {
  const [nonEditable, setNonEditable] = useState(false);
  const [TokenValue, setTokenValue] = useState("None")
  const [removeLocationIndex, setRemoveLocationIndex] = useState(null);
  const [removeUnitTypeIndex, setRemoveUnitTypeIndex] = useState(null);
  const TokenTypeList = ["Pre-Select"];
  const TypeList = ["None", "Priority Pass", "Preselect"]
  useEffect(() => {
    console.log("props",props);
    if (props.title === 'Edit Token') {
      Network.getStatus().then((status) => {
        if (status.connected) {
          checkCurrentTokenIsInEvent().then((tokenPresent) => {
            console.log();
            tokenPresent = tokenPresent.filter(({ eventTokenId }) => eventTokenId !== null);
            console.log({ tokenPresent });
            // ??Token is present in event non editable name and Code
            if (tokenPresent.length > 0) {
              setNonEditable(true);
            }

          });
        } else {
          offlineToast();
        }
      });
    }

  }, [])


  const toCheckShortTokenExistsInTable = debounce(async (shortCod) => {
    const { data, error } = await supabase.from("Tokens")
      .select('*')
      .eq('shortCode', shortCod.toUpperCase());
    if (data) {
      console.log(data)
      if (data.length > 0) {
        props.setHelperText({
          ...props.helperText,
          shortCode: "Short Code already exists",
        });
      } else {
        props.setHelperText({
          ...props.helperText,
          shortCode: "",
        });
      }
    } else {
      errorTost(error.message);
      console.log(error);
    }
  }, 800);

  async function checkCurrentTokenIsInEvent() {
    const { data, error } = await supabase
      .from("EventTokenLeadRelations")
      .select('*,eventTokenId(*,tokenId(*))')
      .eq("eventTokenId.tokenId", props.tokenData.tokenId);

    if (data) return data;
    else throw error;
  }

  async function updateTokenData(id) {
    let flag = props.validatetTokenForm();
    if (
      flag.flag &&
      // ! why check helper texts here? this should be done in validation function itself
      props.helperText.isNameValid === "" &&
      props.helperText.isAmountValid === "" &&
      props.helperText.isUnitTypeSelected === "" &&
      props.helperText.isModeOfPaymentSelected === "" &&
      props.helperText.isValiditySelected === "" &&
      props.helperText.shortCode === "" &&
      props.helperText.NoOfBookingAllow === ""
    ) {
      const tokenObj = { ...props.tokenData };
      delete tokenObj.id;
      delete tokenObj.created_at;
      delete tokenObj.tokenId;
      delete tokenObj.index;
      tokenObj.last_updated_at = Date.now();
      tokenObj.canCustomerRefund = props.customerRefund
      props.setTokenData((pre) => {
        pre.shortCode = tokenObj.shortCode.toUpperCase();
        return { ...pre };
      });
      Network.getStatus().then(async (status) => {
        if (status.connected) {
          const { data, error } = await supabase
            .from("Tokens")
            .update(tokenObj)
            .eq("tokenId", id);

          if (data) {
            props.setOpenAddTokenModal(false);
            successTost("Token Updated Successfully!");
          } else {
            errorTost(error.message);
            console.log(error);
          }
        } else {
          offlineToast();
        }
      });
    }
  }
  const validityList = [45, 60, 90];
  const refundOptionList = ["Yes", "No"];
  const paymentOptionList = ["Full", "Partial"];
  const LEAD_TYPE_OPTIONS = ["Direct", "CP", "R&L"];

  return (
    <Modal
      open={props.open}
      onClose={props.close}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className={cssClasses.container}>
        <div className={cssClasses.header}>
          <p className={cssClasses.heading}>{props.title}</p>
          <CloseIcon
            sx={{ fontSize: "3rem", cursor: "pointer" }}
            onClick={props.close}
          />
        </div>
        <div className={cssClasses.wrapper}>
          <div className={cssClasses.content}>
            <div className={cssClasses.AddTokenModalContent}>
              <p className={cssClasses.subHeading}>Token Details</p>
              <div className={cssClasses.contentWrapper}>
                <div className={cssClasses.key}>
                  Token Name : <span className={cssClasses.mandatory}>*</span>
                </div>
                <div
                  className={cssClasses.value}
                  style={{
                    marginLeft: "7rem",
                  }}
                >
                  <CustomInput
                    placeholder="Token Name"
                    value={props.tokenData.name}
                    handleChange={(e) => {
                      console.log(e);
                      var alphaNumber = /^[0-9*\sA-Z*\sa-z]*$/;
                      if (!e.trim()) {
                        props.helperText.isNameValid =
                          "Please Enter Token Name";
                      } else if (e.length > 50) {
                        props.helperText.isNameValid = "Name Length too large!";
                      } else {
                        props.helperText.isNameValid = "";
                      }
                      if (e.match(alphaNumber)) {
                        props.setTokenData({ ...props.tokenData, name: e });
                      }
                    }}
                    helperText={props.helperText.isNameValid}
                    disabled={nonEditable}
                  />
                </div>
              </div>
              {/* token short Code */}
              <div className={cssClasses.contentWrapper} >
                <div className={cssClasses.key}>
                  Short Code : <span className={cssClasses.mandatory}>*</span>
                </div>
                <div
                  className={cssClasses.value}
                  style={{
                    marginLeft: "7rem",
                  }}
                >
                  <CustomInput
                    placeholder="Short Code"
                    value={props.tokenData.shortCode}
                    handleChange={(e) => {
                      // console.log(e);
                      e = e.trim();
                      var alphaNumber = /^[0-9*\sA-Z*\sa-z]*$/;
                      var regex = /([A-Z*\sa-z])$/;
                      //  if(e.length<=4&&e.match(alphaNumber)){
                      if (e.match(alphaNumber)) {
                        props.setTokenData({ ...props.tokenData, shortCode: e });
                      }
                      if (!e.trim()) {
                        props.helperText.shortCode = "Please Enter short Code";
                      } else if (!regex.test(e.charAt(0))) {
                        props.helperText.shortCode = "First letter must be alphabet";
                      }
                      else if (e.length < 2) {
                        props.helperText.shortCode = "Minimum length should be 2 ";
                      }

                      else {
                        // props.helperText.shortCode = "";
                        toCheckShortTokenExistsInTable(e);
                      }


                    }}
                    helperText={props.helperText.shortCode}
                    disabled={nonEditable}
                  />
                </div>
              </div>
              {/* <div className={cssClasses.contentWrapper}>
                <div className={cssClasses.key}>
                  Is Token type “Pre-Select” :{" "}
                  <span className={cssClasses.mandatory}>*</span>
                </div>
                <div
                  className={cssClasses.value}
                  style={{
                    marginLeft: "2rem",
                  }}
                >
                  //! Use CustomSwitch subcomponent here
                  <CustomSwitch
                    checked={props.tokenData.isPreselect}
                    onChange={(e) => {
                      props.setTokenData({
                        ...props.tokenData,
                        isPreselect: e.target.checked,
                      });
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
              </div> */}
              <div className={cssClasses.contentWrapper}>
                <div className={cssClasses.key}>
                  Select Token Type :{" "}
                  <span className={cssClasses.mandatory}>*</span>
                </div>
                <div
                  className={cssClasses.value}
                  style={{
                    marginLeft: "2.2rem",
                    width: "66%",
                  }}
                >
                  <CustomRadio
                    optionList={TypeList}
                    value={props.tokenData.isPriorityPass ? "Priority Pass" : props.tokenData.isPreselect ? "Preselect" : "None"}
                    onChangeValue={(e) => {
                      console.log('e: ', e);
                      if (e === "Preselect") {
                        props.setTokenData((pre) => {
                          pre.isPreselect = true;
                          pre.isPriorityPass = false;
                          return { ...pre };
                        });
                        props.tokenData.isPreselect = true;
                        props.tokenData.isPriorityPass = false;
                      } else if (e === "Priority Pass") {
                        props.setTokenData((pre) => {
                          pre.isPreselect = false;
                          pre.isPriorityPass = true;
                          return { ...pre };
                        });
                        props.tokenData.isPriorityPass = true;
                        props.tokenData.isPreselect = false;
                      } else {
                        props.setTokenData((pre) => {
                          pre.isPreselect = false;
                          pre.isPriorityPass = false;
                          return { ...pre };
                        });
                        props.tokenData.isPriorityPass = false;
                        props.tokenData.isPreselect = false;
                      }
                    }}
                  />
                  {/* <CustomRadio
                    optionList={TokenTypeList}
                    value={props.tokenData.isPreselect ? "Pre-Select" : ""}
                    onChangeValue={(e) => {
                      if (e === "Pre-Select") {
                        props.setTokenData({
                          ...props.tokenData,
                          isPreselect: true,
                        });
                      }
                    }}
                  /> */}
                </div>
              </div>
              <div className={cssClasses.contentWrapper}>
                <div className={cssClasses.key}>
                  Select Token validity :{" "}
                  <span className={cssClasses.mandatory}>*</span>
                </div>
                <div
                  className={cssClasses.value}
                  style={{
                    marginLeft: "2.2rem",
                    width: "35%",
                  }}
                >
                  <DropDown
                    style={{
                      selectedColor: "#101828",
                      // selectedColor: "#175CD3",
                      // background: "#F2F4F7",
                    }}
                    selectedValue={props.tokenData.validity}
                    onChangeSelect={(e) => {
                      console.log(e);
                      if (!e) {
                        props.helperText.isValiditySelected =
                          "Please Select Validity";
                      } else {
                        props.helperText.isValiditySelected = "";
                      }
                      props.setTokenData({ ...props.tokenData, validity: e });
                    }}
                    helperText={props.helperText.isValiditySelected}
                    list={validityList}
                  />
                  <p>Days</p>
                </div>
              </div>
              <div className={cssClasses.contentWrapper}>
                <div className={cssClasses.key}>
                  Select Unit Type :{" "}
                  <span className={cssClasses.mandatory}>*</span>
                </div>
                <div
                  className={cssClasses.value}
                  style={{
                    marginLeft: "5rem",
                    width: "30%",
                  }}
                >
                  <DropDown
                    style={{
                      selectedColor: "#101828",
                      // background: "#F2F4F7",
                    }}
                    selectedValue={props.selectedUnit[0]?.type}
                    onChangeSelect={(e) => {
                      if (!e) {
                        props.helperText.isUnitTypeSelected =
                          "Please Select Unit Type";
                      } else {
                        props.helperText.isUnitTypeSelected = "";
                      }
                      let selctedIndex = props.unitType.findIndex((unit) => {
                        return unit.type === e;
                      });
                      let selectedUnit = props.unitType[selctedIndex];
                      props.setTokenData({
                        ...props.tokenData,
                        inventoryTypeId: selectedUnit.inventoryTypeId,
                      });
                    }}
                    helperText={props.helperText.isUnitTypeSelected}
                    list={props.unitType.map((unit) => unit.type)}
                  />
                </div>
              </div>
              <div className={cssClasses.contentWrapper}>
                <div className={cssClasses.key}>Pre-requisite :</div>
                <div
                  className={cssClasses.value}
                  style={{
                    marginLeft: "8.5rem",
                    width: "30%",
                  }}
                >
                  {props.tokenArr.length === 0 ? (
                    <DropDown
                      style={{
                        selectedColor: "#101828",
                        // background: "#F2F4F7",
                      }}
                      disable={true}
                      list={[]}
                    />
                  ) : (
                    <DropDown
                      style={{
                        selectedColor: "#101828",
                        // background: "#F2F4F7",
                      }}
                      selectedValue={props.selectedPreRequisite[0]?.name}
                      onChangeSelect={(e) => {
                        let selctedIndex = props.tokenArr.findIndex((token) => {
                          return token.name === e;
                        });
                        let selectedPreRequisite = props.tokenArr[selctedIndex];
                        console.log(selectedPreRequisite);
                        props.setTokenData({
                          ...props.tokenData,
                          prerequisiteId: selectedPreRequisite.tokenId,
                        });
                      }}
                      list={props.tokenArr
                        .filter(
                          (token) =>
                            token.tokenId !== props.tokenData.id &&
                            token.prerequisiteId !== props.tokenData.tokenId
                        )
                        .map((token) => token.name)}
                    />
                  )}
                </div>
              </div>
              {/* <p className={cssClasses.subHeading}>
                Payment Method <span className={cssClasses.mandatory}>*</span>
              </p>
              <p className={cssClasses.paymentHelperText}>
                {props.helperText.isModeOfPaymentSelected}
              </p>
              <div className={cssClasses.paymentMethodList}>
                <div className={cssClasses.leftList}>
                  <FormControlLabel
                    control={<Checkbox  sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}/>}
                    onChange={(e) => {
                      props.handlePaymentSelection(e);
                    }}
                    value="cash"
                    checked={props.updateData?props.tokenData.modeOfPayments?.includes("cash"): props.paymentArr.includes("cash")}
                    label={
                      <Typography
                        sx={{
                          fontFamily: "Inter-Medium",
                          fontSize: "1.4rem",
                          fontWeight: "500",
                          lineHight: "2rem",
                          letterSpacing: "0em",
                          textAlign: "left",
                        }}
                      >
                        Cash
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}/>}
                    value="cheque"
                    checked={props.updateData?props.tokenData.modeOfPayments?.includes("cheque"): props.paymentArr.includes("cheque")}
                    onChange={(e) => {
                      props.handlePaymentSelection(e);
                    }}
                    label={
                      <Typography
                        sx={{
                          fontFamily: "Inter-Medium",
                          fontSize: "1.4rem",
                          fontWeight: "500",
                          lineHight: "2rem",
                          letterSpacing: "0em",
                          textAlign: "left",
                        }}
                      >
                        Cheque
                      </Typography>
                    }
                  />
                </div>
                <div className={cssClasses.rightlist}>
                  <FormControlLabel
                    control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}/>}
                    onChange={(e) => {
                      props.handlePaymentSelection(e);
                    }}
                    value="UPI"
                    checked={props.updateData?props.tokenData.modeOfPayments?.includes("UPI"): props.paymentArr.includes("UPI")}
                    label={
                      <Typography
                        sx={{
                          fontFamily: "Inter-Medium",
                          fontSize: "1.4rem",
                          fontWeight: "500",
                          lineHight: "2rem",
                          letterSpacing: "0em",
                          textAlign: "left",
                        }}
                      >
                        UPI
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}/>}
                    onChange={(e) => {
                      props.handlePaymentSelection(e);
                    }}
                    value="razorpay"
                    checked={
                      props.updateData
                        ? props.tokenData.modeOfPayments?.includes("razorpay")
                        : props.paymentArr.includes("razorpay")
                    }
                    label={
                      <Typography
                        sx={{
                          fontFamily: "Inter-Medium",
                          fontSize: "1.4rem",
                          fontWeight: "500",
                          lineHight: "2rem",
                          letterSpacing: "0em",
                          textAlign: "left",
                        }}
                      >
                        Razorpay
                      </Typography>
                    }
                  />
                </div>
                <FormControlLabel
                  control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}/>}
                  value="card"
                  checked={props.updateData?props.tokenData.modeOfPayments?.includes("card"): props.paymentArr.includes("card")}
                  onChange={(e) => {
                    props.handlePaymentSelection(e);
                  }}
                  label={
                    <Typography
                      sx={{
                        fontFamily: "Inter-Medium",
                        fontSize: "1.4rem",
                        fontWeight: "500",
                        lineHight: "2rem",
                        letterSpacing: "0em",
                        textAlign: "left",
                      }}
                    >
                      Card
                    </Typography>
                  }
                />
              </div> */}
              <div className={cssClasses.contentWrapper}>
                <div className={cssClasses.key}>
                  Token Amount : <span className={cssClasses.mandatory}>*</span>
                </div>
                <div
                  className={cssClasses.value}
                  style={{
                    marginLeft: "7rem",
                    width: "30%",
                  }}
                >
                  <CustomInput
                    value={props.tokenData.amount}
                    placeholder=""
                    inputType="label"
                    position="start"
                    max={10}
                    image={"true"}
                    labelText={RupeeIcon}
                    // ! this icon is not shown
                    handleChange={(e) => {
                      console.log(e);
                      const numberCondition = /^[0-9]\d*(\.\d+)?$/;
                      if (!e.trim()) {
                        props.helperText.isAmountValid = "Please Enter Amount";
                      } else if (!numberCondition.test(e)) {
                        props.helperText.isAmountValid =
                          "Enter Amount in proper format.";
                      } else {
                        props.helperText.isAmountValid = "";
                      }
                      props.setTokenData({ ...props.tokenData, amount: e });
                    }}
                    helperText={props.helperText.isAmountValid}
                  />
                </div>
              </div>
               <div className={cssClasses.contentWrapper}>
                <div className={cssClasses.key}>
                  Number Of Bookings Allowed : <span className={cssClasses.mandatory}>*</span>
                </div>
                <div
                  className={cssClasses.value}
                  style={{
                    marginLeft: "7rem",
                    width: "30%",
                  }}
                >
                 { console.log('first', props.tokenData.NoOfBookingAllow)}
                   <CustomInput
                    placeholder=""
                    value={props.tokenData.NoOfBookingAllow}
                    handleChange={(e) => {
                      console.log(e);
                     
                        props.setTokenData({ ...props.tokenData, NoOfBookingAllow: e });
                      
                    }}
                    helperText={props.helperText.NoOfBookingAllow}
                    disabled={nonEditable}
                  />
                </div>
              </div>
              <div className={cssClasses.contentWrapper} style={{ marginBottom: "0" }}>
                <p
                  className={cssClasses.subHeading}
                  style={{
                    marginRight: "8rem",
                  }}
                >
                  Refund Policy :{" "}
                  <span className={cssClasses.mandatory}>*</span>
                </p>
                <CustomRadio
                  optionList={refundOptionList}
                  value={props.tokenData.isRefundable ? "Yes" : "No"}
                  onChangeValue={(e) => {
                    e === "Yes"
                      ? props.setTokenData({
                        ...props.tokenData,
                        isRefundable: true,
                      })
                      : props.setTokenData({
                        ...props.tokenData,
                        isRefundable: false,
                      }); props.setCustomerRefund(false)
                  }}
                />
              </div>
              {props.tokenData.isRefundable && <div className={cssClasses.contentWrapper} style={{ marginBottom: "0" }}>
                <p
                  className={cssClasses.subHeading}
                  style={{
                    marginRight: "8rem",
                    lineBreak:"normal",
                    width:"120px"
                  }}
                >
                  Can customer initiate a refund ?
                </p>
                <div style={{display: "flex",alignItems: "center",gap: "1rem",fontSize: "1.4rem",color: "#344054"}}>
                  <label>Yes</label>
                <CustomSwitch checked={props.customerRefund}
                sx={{transform: "scaleX(-1)"}} 
                onChange={(event) => {props.setCustomerRefund(event.target.checked);}}
                 />
                 <label>No</label>
                 </div>
              </div>}

              <div className={cssClasses.contentWrapper} style={{ marginBottom: "0" }}>
                <p
                  className={cssClasses.subHeading}
                  style={{
                    marginRight: "8rem",
                  }}
                >
                  Payment Type :{" "}
                </p>
                <CustomRadio
                  optionList={paymentOptionList}
                  value={props.tokenData.paymentType ? "Full" : "Partial"}
                  onChangeValue={(e) => {
                    e === "Full"
                      ? props.setTokenData({
                        ...props.tokenData,
                        paymentType: true,
                      })
                      : props.setTokenData({
                        ...props.tokenData,
                        paymentType: false,
                      });
                  }}
                />
              </div>
              <div className={cssClasses.contentWrapper} style={{ marginBottom: "0" }}>
                <p
                  className={cssClasses.subHeading}
                  style={{ marginRight: "8rem" }}
                >
                  Enable Location :
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "1rem", fontSize: "1.4rem", color: "#344054" }}>
                  <label>Yes</label>
                  <CustomSwitch
                    checked={props.tokenData.isLocationEnabled}
                    sx={{ transform: "scaleX(-1)" }}
                    onChange={(event) => {
                      props.setTokenData({
                        ...props.tokenData,
                        isLocationEnabled: event.target.checked,
                      });
                    }}
                  />
                  <label>No</label>
                </div>
              </div>
              {props.tokenData.isLocationEnabled && (
                <div className={cssClasses.locationListWrapper}>
                  {(props.tokenData.locations || []).map((loc, idx) => (
                    <div className={cssClasses.locationRow} key={idx}>
                      <div style={{ flex: "1" }}>
                        <CustomInput
                          placeholder="Enter location name"
                          value={loc}
                          handleChange={(e) => {
                            const arr = [...(props.tokenData.locations || [])];
                            arr[idx] = e;
                            props.setTokenData({ ...props.tokenData, locations: arr });
                          }}
                        />
                      </div>
                      <div style={{ flexShrink: 0 }}>
                        <Button
                          btnName={"Remove"}
                          clicked={() => {
                            setRemoveLocationIndex(idx);
                          }}
                          style={{
                            borderRadius: "0.4rem",
                            backgroundColor: "#D92D20",
                            color: "#FFFFFF",
                            fontSize: "1.4rem",
                            width: "auto",
                          }}
                          padding={"0.8rem 1.2rem"}
                        />
                      </div>
                    </div>
                  ))}
                  <Button
                    btnName={"+ Add Location"}
                    disable={(props.tokenData.locations || []).some(
                      (loc) => !loc?.trim()
                    )}
                    clicked={() => {
                      props.setTokenData({
                        ...props.tokenData,
                        locations: [...(props.tokenData.locations || []), ""],
                      });
                    }}
                    style={{
                      borderRadius: "0.4rem",
                      backgroundColor: "#1570EF",
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      width: "fit-content",
                    }}
                    padding={"0.5rem 1rem"}
                  />
                </div>
              )}
              <div className={cssClasses.contentWrapper} style={{ marginBottom: "0" }}>
                <p
                  className={cssClasses.subHeading}
                  style={{ marginRight: "8rem" }}
                >
                  Enable Unit Type :
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "1rem", fontSize: "1.4rem", color: "#344054" }}>
                  <label>Yes</label>
                  <CustomSwitch
                    checked={props.tokenData.isUnitTypeEnabled}
                    sx={{ transform: "scaleX(-1)" }}
                    onChange={(event) => {
                      props.setTokenData({
                        ...props.tokenData,
                        isUnitTypeEnabled: event.target.checked,
                      });
                    }}
                  />
                  <label>No</label>
                </div>
              </div>
              {props.tokenData.isUnitTypeEnabled && (
                <div className={cssClasses.locationListWrapper}>
                  {(props.tokenData.unitTypes || []).map((unit, idx) => (
                    <div className={cssClasses.locationRow} key={idx}>
                      <div style={{ flex: "1" }}>
                        <CustomInput
                          placeholder="Enter unit type"
                          value={unit}
                          handleChange={(e) => {
                            const arr = [...(props.tokenData.unitTypes || [])];
                            arr[idx] = e;
                            props.setTokenData({ ...props.tokenData, unitTypes: arr });
                          }}
                        />
                      </div>
                      <div style={{ flexShrink: 0 }}>
                        <Button
                          btnName={"Remove"}
                          clicked={() => {
                            setRemoveUnitTypeIndex(idx);
                          }}
                          style={{
                            borderRadius: "0.4rem",
                            backgroundColor: "#D92D20",
                            color: "#FFFFFF",
                            fontSize: "1.4rem",
                            width: "auto",
                          }}
                          padding={"0.8rem 1.2rem"}
                        />
                      </div>
                    </div>
                  ))}
                  <Button
                    btnName={"+ Add Unit Type"}
                    disable={(props.tokenData.unitTypes || []).some(
                      (unit) => !unit?.trim()
                    )}
                    clicked={() => {
                      props.setTokenData({
                        ...props.tokenData,
                        unitTypes: [...(props.tokenData.unitTypes || []), ""],
                      });
                    }}
                    style={{
                      borderRadius: "0.4rem",
                      backgroundColor: "#1570EF",
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      width: "fit-content",
                    }}
                    padding={"0.5rem 1rem"}
                  />
                </div>
              )}
              <div className={cssClasses.contentWrapper} style={{ alignItems: "flex-start" }}>
                <p
                  className={cssClasses.subHeading}
                  style={{ marginRight: "8rem" }}
                >
                  Allowed Lead Types :
                </p>
                <div className={cssClasses.leadTypeCheckboxRow}>
                  {LEAD_TYPE_OPTIONS.map((opt) => (
                    <FormControlLabel
                      key={opt}
                      control={
                        <Checkbox
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                          checked={(props.tokenData.allowedLeadTypes || []).includes(opt)}
                          onChange={(e) => {
                            const current = props.tokenData.allowedLeadTypes || [];
                            const updated = e.target.checked
                              ? [...current, opt]
                              : current.filter((v) => v !== opt);
                            props.setTokenData({
                              ...props.tokenData,
                              allowedLeadTypes: updated,
                            });
                          }}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            fontFamily: "Inter-Medium",
                            fontSize: "1.4rem",
                            fontWeight: "500",
                          }}
                        >
                          {opt}
                        </Typography>
                      }
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={cssClasses.footer}>
          <div className={cssClasses.footerWrapper} >
            <div style={{ width: "fit-Content", marginRight: "1rem" }}>
              <Button
                btnName={"Cancel"}
                style={{
                  color: "#344054",
                  backgroundColor: "#ffffff",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                padding={"0.85rem 2.6rem"}
                clicked={props.close}
              />
            </div>

            {props.updateData === true ? (
              <Button
                btnName={"Update"}
                style={{
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                }}
                clicked={() => updateTokenData(props.tokenData.id)}
                padding={"0.8rem 3.2rem"}
              />
            ) : (
              <Button
                btnName={"Save"}
                style={{
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                }}
                clicked={() => props.sendTokenData()}
                padding={"0.8rem 3.2rem"}
              />
            )}
          </div>
        </div>
        {removeLocationIndex !== null && (
          <ConfirmationAlert
            confirm={(e) => {
              if (e === "confirmed") {
                const arr = (props.tokenData.locations || []).filter(
                  (_, i) => i !== removeLocationIndex
                );
                props.setTokenData({ ...props.tokenData, locations: arr });
              }
              setRemoveLocationIndex(null);
            }}
            buttonTitle={"Cancel"}
            returnRespButton={"Remove"}
            close={() => setRemoveLocationIndex(null)}
            title={"Remove Location"}
            subTitle={"Are you sure you want to remove this location?"}
            open={removeLocationIndex !== null}
          />
        )}
        {removeUnitTypeIndex !== null && (
          <ConfirmationAlert
            confirm={(e) => {
              if (e === "confirmed") {
                const arr = (props.tokenData.unitTypes || []).filter(
                  (_, i) => i !== removeUnitTypeIndex
                );
                props.setTokenData({ ...props.tokenData, unitTypes: arr });
              }
              setRemoveUnitTypeIndex(null);
            }}
            buttonTitle={"Cancel"}
            returnRespButton={"Remove"}
            close={() => setRemoveUnitTypeIndex(null)}
            title={"Remove Unit Type"}
            subTitle={"Are you sure you want to remove this unit type?"}
            open={removeUnitTypeIndex !== null}
          />
        )}
      </div>
    </Modal>
  );
}

export default AddTokenModal;
